import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import NormalGameManager from "../../manager/NormalGameManager";
import takeCowPage from "./takeCowPage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class takeCowAddRopePage extends cc.Component {

    @property({type:cc.Node,tooltip:"免费节点"})
    freeNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"钱节点"})
    moneyNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"视频节点"})
    videoNode:cc.Node = null;

    @property({type:cc.Label,tooltip:"钱文本"})
    lbMoney:cc.Label = null;

    needCoin:number = 0;

    takeCow:takeCowPage = null;

    comitFun:()=>void = null;

    noFun:()=>void = null;

    start(){
        cc.director.pause();
    }

    setType(type:number,takeCow:takeCowPage,comitFun:()=>void,noFun:()=>void){
        this.takeCow = takeCow;
        this.freeNode.active = false;
        this.moneyNode.active = false;
        this.videoNode.active = false;
        this.comitFun = comitFun;
        this.noFun = noFun;
        switch(type){
            case 0:{
                this.freeNode.active = true;
                break;
            }
            case 1:{
                    this.moneyNode.active = true;
                    this.needCoin = 1000000;
                    this.updateMoneyNode();
                break;
            }
            case 2:{
                    this.moneyNode.active = true;
                    this.needCoin = 2000000;
                    this.updateMoneyNode();
                break;
            }
            case 3:{
                    this.videoNode.active = true;
                break;
            }
        }
    }

    updateMoneyNode(){
        this.lbMoney.string = this.needCoin.toString();
    }

    onBtnComit(){
        this.comitFun && this.comitFun();
        this.closeThis();
    }

    onBtnCancel(){
        this.noFun && this.noFun();
        this.closeThis();
    }

    onBtnPay(){
        let coin = O1HD.getServices().userSrv.getCoins();
        if(coin < this.needCoin){
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins(-this.needCoin,true);
        this.comitFun && this.comitFun();
        this.closeThis();
    }

    onBtnLookVideo(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.comitFun && this.comitFun();
            this.closeThis();
        },()=>{

        },null,"套牛看视频增加绳子");
    }

    closeThis(){
        this.node.destroy();
    }

}
